import { CardHeader } from '../../../components/ui/card';
import { Card } from '../../../components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface MetricCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  isLoading: boolean;
  tooltip?: string;
}

export function MetricCard({ title, value, icon, isLoading, tooltip }: MetricCardProps) {
  return (
    <Card className="rounded-lg border">
      <CardHeader className="pt-4 pr-6 pb-6 pl-6 flex justify-between font-mono">
        {isLoading ? (
          <>
            <div className="flex flex-row justify-between items-baseline w-full">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
            <Skeleton className="h-9 w-28 mt-2" />
          </>
        ) : (
          <>
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row items-center gap-1 justify-baseline text-xs text-muted-foreground">
                <span className="tracking-[0.04em]">{title}</span>
                {tooltip && (
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Info className="h-3.5 w-3.5 text-muted-foreground cursor-pointer" />
                      </TooltipTrigger>
                      <TooltipContent className="font-sans max-w-[300px]">
                        <p>{tooltip}</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                )}
              </div>
              <div className="flex gap-1 justify-end">
                <div className="rounded-full bg-primary text-primary-foreground p-2 flex items-center justify-center">
                  {icon}
                </div>
              </div>
            </div>
            <div className="flex gap-1 justify-baseline text-3xl font-sans font-semibold text-foreground">
              {value}
            </div>
          </>
        )}
      </CardHeader>
    </Card>
  );
}
